// extracted by mini-css-extract-plugin
export default {"container":"Jo-z","ratingLayout":"Ko-z","ratingLabel":"Lo-z","nonInteractiveRatingLabel":"Mo-z"};